var __TEMP__ = require('./isSymbol.js');var isSymbol = __REQUIRE_DEFAULT__(__TEMP__);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = toKey;
